import { Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react'
import FormUpdateContact from './FormUpdateContact'
import { useState } from 'react';
import QueueUpdateContactContext, { defaultQueueUpdateFormValue } from '../../context/formUpdateContactContext'


const UpdateContactNotice = () => {
    const bg = useColorModeValue('blue.400', 'blue.800')
    const bg2 = useColorModeValue('white', 'blackAlpha.600')
    const [updateContactData, setUpdateContact] = useState(defaultQueueUpdateFormValue)

    return (
        <QueueUpdateContactContext.Provider value={[updateContactData, setUpdateContact]}>
            <Flex minH={{sm:"100vh",md:"80vh"}} backgroundColor={bg}>
                <Flex w="full" direction="column" align="center" justify="center" m={{sm:4,md:10}} p={10} shadow="md" borderRadius="lg" bgColor={bg2}>
                    <Heading as='h2' size='lg' textAlign="center">ปรับปรุงข้อมูลติดต่อสำหรับผู้รอคิว</Heading>
                    <Text fontSize='md' mt={4}>สำหรับผู้ที่รอคิวที่ยื่นเอกสารคำร้องขอเข้าพักอาศัยฯ ก่อนวันที่ 1 สิงหาคม 2565 (ยื่นกระดาษ)</Text>
                    <Text fontSize='md' mt={2} color="red">กรุณากรอกชื่อและนามสกุล หมายเลขโทรศัพท์มือถือ และอีเมลของตนเองให้ครบถ้วนถูกต้อง</Text>
                    <Text fontSize='md' color="red">เพื่อให้ระบบสามารถจัดส่งการแจ้งเตือนไปยังท่านได้</Text>
                    <FormUpdateContact />
                </Flex>
            </Flex>
        </QueueUpdateContactContext.Provider>
    )
}

export default UpdateContactNotice